import * as React from "react";
import styled from "styled-components";
import { Tooltip as ReactTippy } from "react-tippy";
import type { TooltipProps as ReactTippyTooltipProps } from "react-tippy";

import Utils from "pages/common/lib/grabyo-util";

import mainTheme from "style/theme";

export type TooltipColorTheme = "grabyo" | "grabyo-transparent" | "light";

export interface TooltipProps extends ReactTippyTooltipProps {
    innerHtml?: React.ReactNode;
    innerHtmlStyle?: React.CSSProperties & {
        linkColor?: string;
        fontSize?: string;
    };
    coverParent?: boolean;
    backgroundColor?: string;
    children?: React.ReactNode;
    colorTheme?: TooltipColorTheme;
    maxWidth?: number;
}

class Tooltip extends React.Component<TooltipProps> {
    render() {
        const {
            coverParent,
            popperOptions,
            style,
            innerHtmlStyle,
            innerHtml,
            trigger = `mouseenter`,
            position = `top`,
            size = `regular`,
            arrow = true,
            hideOnClick = true,
            interactive = true,
            tabIndex = 0,
            disabled = false,
            distance = 0,
            followCursor = false,
            maxWidth,
            colorTheme = `grabyo`,
            backgroundColor
        } = this.props;
        return (
            <ReactTippy
                {...this.props}
                trigger={trigger}
                position={position}
                size={size}
                arrowSize="small"
                html={
                    <InnerHtml
                        theme={mainTheme}
                        styles={innerHtmlStyle}
                        colorTheme={colorTheme}
                        backgroundColor={backgroundColor}
                    >
                        <>{innerHtml}</>
                    </InnerHtml>
                }
                arrow={arrow}
                hideOnClick={hideOnClick}
                unmountHTMLWhenHide={true}
                interactive={interactive}
                tabIndex={tabIndex}
                disabled={disabled}
                sticky={false}
                distance={distance}
                followCursor={followCursor}
                //@ts-ignore: not sure how this fits in
                theme={colorTheme}
                popperOptions={Utils.tooltipPopperOptions({
                    ...popperOptions,
                    maxWidth
                })}
                style={{ ...style, display: coverParent ? `block` : `inherit` }}
            >
                {this.props.children}
            </ReactTippy>
        );
    }
}

export default Tooltip;

export const InnerHtml = styled.section<{
    styles?: {
        linkColor?: string;
        fontSize?: string;
    };
    colorTheme?: TooltipColorTheme;
    backgroundColor?: string;
}>`
    color: ${(props) =>
        props.colorTheme === "grabyo"
            ? props.theme.colors.text3
            : props.theme.colors.primaryText};
    background-color: ${(props) => props.backgroundColor};
    font-size: ${(props) => props.styles?.fontSize ?? `11px`};
    font-weight: ${(props) => props.theme.fontWeightSemiBold};
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    z-index: ${(props) => props.theme.zIndex.tooltip};
    margin: 0;
    padding: 0;

    a {
        color: ${(props) => props?.styles?.linkColor ?? `#fff`};
        font-weight: ${(props) => props.theme.fontWeightSemiBold};
    }
`;

export type { Position as TooltipPosition } from "react-tippy";
export type { Size as TooltipSize } from "react-tippy";
